module.exports = __webpack_public_path__ + "img/logout_black_24dp.c9fc3bf5.svg";